import React from "react";
import { List } from "../modules/Settings/PackageSizes";

export function PackageListPage() {
  return <List />;
}
